module.exports = __webpack_public_path__ + "static/media/hero-1.6c310609.png";